import { defineMessages } from 'react-intl';

export const errorFallbackMessages = defineMessages({
  notification: {
    id: 'imageZoom.errorFallback.notification',
    defaultMessage:
      'Fehler beim Laden. Bitte überprüfe deine Internetverbindung und versuche es erneut.',
  },
});
